var exports = {
  "k": "TimestampWithTooltip.module__container___VmhkaH",
  "N": "TimestampWithTooltip.module__hiddenSpacer___VmhkaH",
};

module.exports = exports;
